import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "react-bootstrap";

import { logout, changeMyPassword } from "../../actions/auth";
import Notifications from "../notifications";
import PasswordBar from "../../layout/password";

const DEFAULT_AVATAR = "https://www.gravatar.com/avatar/HASH?d=mp&s=24";

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: {
        fullscreen: false,
        password: false,
      },
      password: {
        original: "",
        new: "",
        confirmed: "",
        score: 0
      },
      showUserMenu: false,
    };
    this.userMenuRef = React.createRef();
  }

  componentDidMount = () => {
    document.addEventListener("mousedown", this.onDocumentMouseDown);
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this.onDocumentMouseDown);
  };

  onDocumentMouseDown = (event) => {
    if (!this.state.showUserMenu) return;
    if (this.userMenuRef.current?.contains(event.target)) return;
    this.setState({ showUserMenu: false });
  };

  onUserMenuToggle = (event) => {
    event.preventDefault();
    this.setState((prev) => ({ showUserMenu: !prev.showUserMenu }));
  };

  onChangePasswordClick = () => {
    this.setState((prev) => ({
      ...prev,
      showUserMenu: false,
      display: {
        ...prev.display,
        password: true,
      },
    }));
  };

  onSignOutClick = () => {
    this.setState({ showUserMenu: false }, this.props.logout);
  };

  setNewPassword = (e) => {
    this.setState({
      ...this.state,
      password: { ...this.state.password, new: e },
    });
  };

  setConfirmedPassword = (e) => {
    this.setState({
      ...this.state,
      password: { ...this.state.password, confirmed: e },
    });
  };

  onPasswordScored = (score, feedback) => {
    this.setState(prev => ({
      ...prev,
      password: {
        ...prev.password,
        score
      }
    }));
  };

  hideChangePassword = () => {
    this.setState({
      ...this.state,
      display: {
        ...this.state.display,
        password: false,
      },
      password: {
        original: "",
        new: "",
        confirmed: "",
      },
      passwordCompliance: {
        score: 0,
        feedback: [],
      },
    });
  };

  onClickSavePassword = async () => {
    const { original, new: newPassword, confirmed, score } = this.state.password;

    if (!original || !newPassword || !confirmed) {
      return;
    }

    if (newPassword !== confirmed) {
      return;
    }

    if (score < 4) {
      return;
    }

    const result = await this.props.changeMyPassword({
      original,
      newPassword,
    });

    if (result?.success) {
      this.setState({
        ...this.state,
        password: {
          original: "",
          new: "",
          confirmed: "",
        },
        passwordCompliance: {
          score: 0,
          feedback: [],
        },
        display: {
          ...this.state.display,
          password: false,
        },
      });
    }
  };

  isInFullScreenFn = () => {
    return (
      (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null)
    );
  };

  toggleFullScreen = () => {
    const isFS = this.isInFullScreenFn();

    const docElm = document.documentElement;
    if (!isFS) {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }

    this.setState({
      ...this.state,
      display: {
        fullscreen: !isFS,
        change: false,
      },
    });
  };

  render() {
    const { original, new: newPassword, confirmed, score } = this.state.password;
    const avatar = this.props?.user?.avatar || DEFAULT_AVATAR;
    const email = this.props?.user?.email || "";

    const passwordsMatch = !!newPassword && !!confirmed && newPassword === confirmed;
    const hasMismatch = !!confirmed && newPassword !== confirmed;
    const meetsCompliance = score >= 4;

    const canSave =
      !!original &&
      !!newPassword &&
      !!confirmed &&
      passwordsMatch &&
      meetsCompliance;

    return (
      <nav id="nav" className="nav-container d-flex" style={{ borderRadius: "0" }}>
        <div className="nav-content d-flex">
          <div className="logo position-relative">
            <Link to="/dashboard">
              <div
                className="img"
                style={{ width: "70em", backgroundImage: `url(${localStorage.smallLogo})` }}
              />
            </Link>
          </div>

          <div className="user-container d-flex">
            <div ref={this.userMenuRef} className="dropdown dropdown-menu-right">
              <button
                type="button"
                className="d-flex user position-relative dropdown-toggle border-0"
                style={{ borderRadius: "0", backgroundColor: "transparent" }}
                aria-expanded={this.state.showUserMenu}
                onClick={this.onUserMenuToggle}
              >
                <img className="profile" alt="Profile" src={avatar} />
                <div className="name">{email}</div>
              </button>

              <div className={`dropdown-menu dropdown-menu-end mt-3${this.state.showUserMenu ? " show" : ""}`}>
                <button type="button" className="dropdown-item" onClick={this.onChangePasswordClick}>
                  Change password
                </button>
                <button type="button" className="dropdown-item" onClick={this.onSignOutClick}>
                  Sign out
                </button>
              </div>
            </div>
          </div>

          <div className="menu-container flex-grow-1"></div>

          <Notifications />

          {this.state.display.password ? (
            <Modal show={true} onHide={this.hideChangePassword}>
              <ModalHeader closeButton>Change Password</ModalHeader>
              <ModalBody>
                <div className="form-group col-md-12">
                  <label className="text-muted text-small">Current Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="originalPassword"
                    name="originalPassword"
                    value={original}
                    onChange={(e) =>
                      this.setState({
                        ...this.state,
                        password: {
                          ...this.state.password,
                          original: e.target.value,
                        },
                      })
                    }
                  />
                </div>

                <div className="form-group col-md-12">
                  <label className="text-muted text-small">New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="newPassword"
                    name="newPassword"
                    value={newPassword}
                    onChange={(e) => this.setNewPassword(e.target.value)}
                  />

                  <div className="mt-2">
                    <PasswordBar password={newPassword} minLength={8} score={score} upper={1} lower={1} symbol={1} number={1} onChangeScore={this.onPasswordScored} />
                  </div>
                </div>

                <div className="form-group col-md-12">
                  <label className="text-muted text-small">Confirm New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="confirmedPassword"
                    name="confirmedPassword"
                    value={confirmed}
                    onChange={(e) => this.setConfirmedPassword(e.target.value)}
                  />

                  {hasMismatch && (
                    <small className="text-danger d-block mt-2">
                      Passwords do not match.
                    </small>
                  )}
                </div>
              </ModalBody>

              <ModalFooter>
                <Button variant="primary" onClick={this.onClickSavePassword} disabled={!canSave}>
                  Save
                </Button>
                <Button variant="secondary" onClick={this.hideChangePassword}>
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
        </div>

        <div className="nav-shadow"></div>
      </nav>
    );
  }
}

Navbar.propTypes = {
  logout: PropTypes.func.isRequired,
  changeMyPassword: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  user: state.auth.user,
});

export default connect(mapStateToProps, { logout, changeMyPassword })(Navbar);
